"use client";

import React from "react";
import CtaBand from "@/components/common/CtaBand";
import { useLanguage } from "@/hooks/useLanguage";
import { pick, type Lang } from "@/lib/i18n";
import { COMMON } from "@/lib/commonCopy";
interface Copy {
  eyebrow: string;
  heading: string;
  lead: string;
  secondaryLabel: string;
}
const copyData: Record<Lang, Copy> = {
  en: {
    eyebrow: "Technical Mesh Selection",
    heading: "Need Help Selecting the Right Mesh Specification?",
    lead: "Send your target aperture, wire diameter, operating pressure, or drawings. Our filtration specialists will review your application and recommend the optimal stainless steel alloy and weave structure.",
    secondaryLabel: "Contact Our Team"
  },
  zh: {
    eyebrow: "技术丝网选型",
    heading: "需要协助选择合适的丝网规格？",
    lead: "请发送您的目标孔径、丝径、工作压力或技术图纸。我们的过滤技术专家将评估工况需求，并推荐适配的不锈钢材质与编织结构。",
    secondaryLabel: "联系工程团队"
  },
  es: {
    eyebrow: "Selección técnica de mallas",
    heading: "¿Necesita ayuda para seleccionar la especificación de malla adecuada?",
    lead: "Envíenos su abertura requerida, diámetro de alambre, presión de trabajo o planos. Nuestros especialistas recomendarán la aleación de acero inoxidable y la estructura de tejido óptimas.",
    secondaryLabel: "Contactar al equipo"
  },
  de: {
    eyebrow: "Technische Gewebeauswahl",
    heading: "Benötigen Sie Unterstützung bei der Auswahl der passenden Maschenspezifikation?",
    lead: "Senden Sie uns Ihre gewünschte Maschenweite, Drahtstärke, Betriebsdrücke oder Zeichnungen. Unsere Filterspezialisten prüfen Ihre Einsatzbedingungen und empfehlen die optimale Legierung und Webart.",
    secondaryLabel: "Team kontaktieren"
  },
  fr: {
    eyebrow: "Sélection technique de toile métallique",
    heading: "Besoin d'aide pour sélectionner la spécification de toile appropriée ?",
    lead: "Envoyez-nous votre ouverture cible, diamètre de fil, pression de service ou plans. Nos spécialistes évalueront vos conditions et recommanderont le bon alliage d'acier inoxydable et l'armure de tissage.",
    secondaryLabel: "Contacter l'équipe"
  },
  pt: {
    eyebrow: "Seleção técnica de malhas",
    heading: "Precisa de ajuda para selecionar a especificação correta de malha?",
    lead: "Envie sua abertura desejada, diâmetro de fio, pressão de trabalho ou desenhos técnicos. Nossos especialistas avaliarão suas condições e recomendarão a liga de aço inoxidável e a tecelagem ideais.",
    secondaryLabel: "Fale com a equipe"
  }
};
export default function QuoteCta() {
  const {
    lang
  } = useLanguage();
  const content = pick(lang, copyData);
  return <CtaBand id="technicalquotecta" eyebrow={content.eyebrow} heading={content.heading} lead={content.lead} primary={{
    label: pick(lang, COMMON.requestQuote),
    to: "/RequestAQuotePage"
  }} secondary={{
    label: content.secondaryLabel,
    to: "/ContactPage"
  }} />;
}